<template>
    <div class="interest-section grid grid__all-around">
        <h2 class="interest-section--title" v-if="content.title" v-text="content.title"></h2>

        <div class="grid--row interest-section--row">
            <component class="grid--col interest-section--col"
                    v-for="(plugin, pluginIdx) in filteredPlugins" :key="pluginIdx"
                    :is="plugin.type"
                    :plugin="plugin">
            </component>
        </div>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
        ],
        computed: {
            filteredPlugins() {
                return this.plugins.filter(plugin => {
                    return this.$route.fullPath !== this.$router.resolve(plugin.content.href).route.fullPath;
                }).slice(0, 4);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?476b0103